import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import StyledLabel from "../Label/StyledLabel";
import { Button } from "reactstrap";
import { IUser } from "../../interfaces/user";
import { useUser } from "../../hooks/useUser";

interface AddUserProps {
  User?: IUser;
}

export const FormUser: React.FC<AddUserProps> = ({ User }) => {
  const { handleSave, isSaving } = useUser();

  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<IUser>({
    defaultValues: {
      ...User,
    },
  });

  const onSubmit = (data: IUser) => {
    handleSave(data, !!User, User?.id);
  };

  useEffect(() => {
    if (User) {
      setValue("name", User.name);
      setValue("rule", User.rule);
      setValue("email", User.email);
    }
  }, [User]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-md-6 mb-3">
          <StyledLabel>Nome:*</StyledLabel>
          <input
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            type="text"
            placeholder="Nome do usuário"
            {...register("name", { required: "Nome é obrigatório." })}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
          {errors.name && (
            <div className="invalid-feedback d-block">
              {errors.name.message}
            </div>
          )}
        </div>

        {/* <div className="col-md-6 mb-3">
          <StyledLabel>Regra (Rule):*</StyledLabel>
          <input
            className={`form-control ${errors.rule ? "is-invalid" : ""}`}
            type="text"
            placeholder="Ex: admin, editor, etc."
            {...register("rule", { required: "A regra é obrigatória." })}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
          {errors.rule && (
            <div className="invalid-feedback d-block">
              {errors.rule.message}
            </div>
          )}
        </div> */}

        <div className="col-md-6 mb-3">
          <StyledLabel>Email:*</StyledLabel>
          <input
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            type="email"
            placeholder="Email"
            {...register("email", { required: "Email é obrigatório." })}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
          {errors.email && (
            <div className="invalid-feedback d-block">
              {errors.email.message}
            </div>
          )}
        </div>

        <div className="col-md-6 mb-3">
          <StyledLabel>Senha:*</StyledLabel>
          <input
            className={`form-control ${errors.password ? "is-invalid" : ""}`}
            type="text"
            placeholder="Senha"
            {...register("password", { required: "Senha é obrigatória." })}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
          {errors.password && (
            <div className="invalid-feedback d-block">
              {errors.password.message}
            </div>
          )}
        </div>
      </div>
      <hr />

      <div className="row">
        <div className="col-md-12 mb-3 d-flex justify-content-end">
          <Button
            type="submit"
            disabled={isSaving}
            style={{
              backgroundColor: "#78E01D",
              borderColor: "#78E01D",
              fontWeight: 500,
              minWidth: "120px",
            }}
          >
            {isSaving ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Salvando...
              </>
            ) : (
              "Salvar"
            )}
          </Button>
        </div>
      </div>
    </form>
  );
};
